<ion-content *ngIf="tabs">
  <app-tabs class="sub-tabs" [renderTabs]="tabs"></app-tabs>
  <ion-router-outlet class="outlet" [animated]="false"></ion-router-outlet>
</ion-content>
